import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Sparkles } from 'lucide-react';
import { apiClient } from '../services/api';
import { API_BASE_URL } from '../config';
import Footer from '../components/Footer';

const LandingPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // Capturar parámetros UTM y extraer promoter_id
    const utmSource = searchParams.get('utm_source');
    
    if (utmSource) {
      // Extraer promoter_id ignorando el prefijo "5-"
      // Ejemplo: "5-1" -> "1"
      const promoterId = utmSource.replace(/^5-/, '');
      
      // Verificar si ya se registró la visita
      const visitRegistered = localStorage.getItem(`promoter_visit_${promoterId}`);
      console.log('Promoter ID:', promoterId, 'Visit Registered:', visitRegistered);
      if (!visitRegistered && promoterId) {
        // Guardar promoter_id en localStorage
        localStorage.setItem('promoter_id', promoterId);
        
        // Registrar visita en el backend (solo una vez)
        apiClient.post(`${API_BASE_URL}/api/promoter/visit`, { promoter_id: promoterId })
          .then(() => {
            // Marcar como registrado para no volver a hacerlo
            localStorage.setItem(`promoter_visit_${promoterId}`, 'true');
          })
          .catch((error) => {
            console.error('Error registrando visita de promotor:', error);
          });
      } else if (promoterId) {
        // Si ya se registró, solo guardar el promoter_id si no existe
        if (!localStorage.getItem('promoter_id')) {
          localStorage.setItem('promoter_id', promoterId);
        }
      }
    }
  }, [searchParams]);

  return (
    <div className="min-h-screen bg-black flex flex-col items-center justify-between px-6 relative overflow-hidden py-4 sm:py-8">
      {/* Subtle decorative elements */}
      <div className="absolute top-20 right-20 w-32 h-32 rounded-full bg-white/5 blur-3xl"></div>
      <div className="absolute bottom-20 left-20 w-40 h-40 rounded-full bg-white/5 blur-3xl"></div>
      
      <div className="max-w-2xl w-full text-center space-y-6 sm:space-y-8 md:space-y-12 relative z-10 flex-1 flex flex-col justify-center">
        {/* Icon */}
        <div className="flex justify-center">
          <span className="text-4xl leading-none">👀</span>
        </div>

        {/* Main heading */}
        <div className="space-y-3 sm:space-y-4">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white tracking-tight leading-tight">
            <span className="block whitespace-nowrap">Bienvenido a</span>
            <span className="block whitespace-nowrap text-[#24b183]">CCE Puebla</span>
          </h1>
          <p className="text-lg sm:text-xl text-[#A2A2A2] font-light">
            Accede a beneficios exclusivos
          </p>
          <p className="text-2xl sm:text-3xl font-bold text-[#24b183]">$277</p>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-2 sm:pt-4">
          <Button 
            onClick={() => navigate('/signup')}
            className="w-full sm:w-auto bg-[#24b183] text-white hover:bg-[#1f9a72] rounded-full px-8 py-6 text-lg font-semibold transition-all hover:scale-105 active:scale-95 shadow-lg"
          >
            Únete a CCE Puebla
          </Button>
          <Button 
            onClick={() => navigate('/login')}
            variant="outline"
            className="w-full sm:w-auto border-[#24b183] text-[#24b183] bg-transparent hover:bg-[#24b183]/10 rounded-full px-8 py-6 text-lg font-semibold transition-all hover:scale-105 active:scale-95"
          >
            Iniciar sesión
          </Button>
        </div>

        {/* Link to preview */}
        <div className="pt-4 sm:pt-6 md:pt-8">
          <button 
            onClick={() => navigate('/stores-preview')}
            className="text-[#A2A2A2] hover:text-white transition-colors text-xs sm:text-sm"
          >
            Ver tiendas participantes y beneficios 👀
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="w-full px-4 sm:px-6 pb-2 sm:pb-4 relative z-10 mt-auto">
        <div className="max-w-2xl mx-auto text-center space-y-1.5 sm:space-y-2 md:space-y-3">
          <p className="text-[#A2A2A2] text-xs sm:text-sm leading-relaxed px-2">
            Copyright 2025 CCE Puebla - La nueva forma de obtener beneficios en las tiendas del Outlet Puebla
          </p>
          <p className="text-[#A2A2A2] text-xs sm:text-sm leading-relaxed px-2 break-words">
            Conoce los{' '}
            <button 
              onClick={() => navigate('/terms')}
              className="text-[#24b183] hover:text-[#1f9a72] transition-colors underline font-medium whitespace-nowrap"
            >
              términos y condiciones
            </button>
            {' '}y la{' '}
            <button 
              onClick={() => navigate('/privacy')}
              className="text-[#24b183] hover:text-[#1f9a72] transition-colors underline font-medium whitespace-nowrap"
            >
              política de privacidad
            </button>
            {' '}de CCE Puebla.
          </p>
          <Footer className="mt-4" />
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
